An opaque cursor to the earlier bounding webhook subscription replay.

Resulting subscription replays will _succeed_ this cursor.
